<script>
    /** @type {number} Nombre à formater */
    export let number;
    /** @type {('currency')} Format à appliquer */
    export let type = "percent";
    /** @type [string] Langue à utiliser */
    export let locale = "fr";
    export let subs = false;
    export let noZero = false;

    if (subs && number > 0) {
        number = number * -1;
    }

    let formattedNumber = new Intl.NumberFormat(locale, {
        style: type,
        minimumFractionDigits: 2,
        maximumFractionDigits: 3,
    }).format(number);

    if (noZero && (number === 0 || number === 0.0)) {
        formattedNumber = "";
    }
</script>

<span>{formattedNumber}</span>

<style>
    span {
        font-variant-numeric: tabular-nums;
    }
</style>
